import { render, staticRenderFns } from "./TestimonialList.vue?vue&type=template&id=557a17dd&scoped=true&"
import script from "./TestimonialList.vue?vue&type=script&lang=ts&"
export * from "./TestimonialList.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialList.vue?vue&type=style&index=0&id=557a17dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557a17dd",
  null
  
)

export default component.exports